import {
    OutwardServiceData,
    OutwardServiceResponse,
    OutwardServiceQuery,
    OutwardServiceUpdateParams,
    OutwardServiceCreationParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/outward-service';

export class OutwardServiceApi {
    public static async find(
        params: OutwardServiceQuery,
    ): Promise<{ outwardServices: OutwardServiceData[]; count: number }> {
        const res = await axios.get<OutwardServiceResponse>(`${BASE_URL}`, { params });

        return res.data;
    }

    public static async create(outwardService: OutwardServiceCreationParams): Promise<void> {
        await axios.post(`${BASE_URL}`, outwardService);
    }

    public static async update(outwardServiceId: string, params: OutwardServiceUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${outwardServiceId}`, params);
    }

    public static async remove(outwardServiceId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${outwardServiceId}`);
    }
}
